import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import { openTearSheet } from '../../../actions';

export const BaseHeader = ({
  headers,
  data,
  title,
  strategyFile,
  openTearSheet,
  accessToTearSheets,
  subtitle = null,
  disclaimer = null,
  isSingleColumn = false,
  documentType = '',
}) => {
  if (!data) {
    return null;
  }
  const history = useHistory();
  const leftElements = [];
  const rightElements = [];
  let current = leftElements;
  let other = rightElements;
  _.each(headers, (header) => {
    if (header.field !== '' && header.title !== '') {
      const el = (
        <Col md={12} key={header.field}>
          <span className="detailTitle">{header.title}: </span>
          {data[header.field]}
        </Col>
      );
      current.push(el);
    }
    if (!isSingleColumn) {
      [current, other] = [other, current];
    }
  });
  const subtitleElement = subtitle && (
    <Col md={12}>
      <h5>{subtitle}</h5>
    </Col>
  );

  if (accessToTearSheets && strategyFile) {
    current.push(
      <Col md={12} className="noPrint">
        <div
          className="strategy-download"
          onClick={() => openTearSheet(strategyFile)}>
          <i className="fa fa-file-download"></i>
          {strategyFile.title}
        </div>
      </Col>
    );
  }

  const elementsRender = colElementsRender(
    isSingleColumn,
    leftElements,
    rightElements
  );

  const back = () => {
    history.goBack();
  };

  return (
    <Row className="fpl-header">
      <div>
        <div className="back-button noPrint" onClick={back}>
          <i className="fas fa-chevron-left icon"></i>
          <span className="text"> Back</span>
        </div>
        {disclaimer}
      </div>
      <Col md={12} className="noPrint">
        <h4>{title}</h4>
      </Col>
      {subtitleElement}
      {elementsRender}
    </Row>
  );
};

const colElementsRender = (isSingleColumn, leftElements, rightElements) => {
  if (isSingleColumn) {
    return (
      <Col md={12}>
        <Row>{leftElements}</Row>
      </Col>
    );
  }

  return (
    <Col md={12}>
      <Row>
        <Col md={6}>
          <Row>{leftElements}</Row>
        </Col>
        <Col md={6}>
          <Row>{rightElements}</Row>
        </Col>
      </Row>
    </Col>
  );
};

BaseHeader.propTypes = {
  headers: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  data: PropTypes.object,
  disclaimer: PropTypes.element,
  isSingleColumn: PropTypes.bool,
  accessToTearSheets: PropTypes.bool,
  documentType: PropTypes.string,
  strategyFile: PropTypes.object,
  openTearSheet: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    strategyFile: state.resources.strategy_file.data,
    accessToTearSheets: state.ui.selectedPlan
      ? state.ui.selectedPlan.accessToTearSheets
      : true,
  };
};

export default connect(mapStateToProps, {
  openTearSheet,
})(BaseHeader);
